import {cs}                from "../../react/chain-services";
import {GlobalResizeState} from "../browser/global-resize-state";

// @deprecated use responsive-2
export const Responsive3 = ({responsive, next}) => cs(
    ["minSizes", (_, next) => next(Object.keys(responsive).filter(v=>v!=="").map((v) => +v))],
    ["sizeState", ({minSizes}, next) => GlobalResizeState({
        translate: ({width}) => minSizes.find((s) => s < width),
        next,
    })],
    ({sizeState}) => next(responsive[sizeState ?? ""])
);
